












































import { mapGetters } from "vuex";
import Vue from "vue";
import Pagination from "@/components/Molecules/Pagination/index.vue";
export default Vue.extend({
  components: {
    Pagination,
  },
  methods: {
    downloadCanvas() {
      const url = (this as any).$refs.canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `${this.getImages[this.getOptions.imageIndex].name}.png`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },

  computed: {
    ...mapGetters({
      getImages: "image/getImages",
      getOptions: "editor/getOptions",
    }),
  },
});
